import React from "react";
import { Reveal } from "../common/Reveal";

export function About() {
  const values = [
    {
      title: "Design Excellence",
      text: "Award-worthy aesthetics with enduring structural integrity",
      icon: (
        <svg
          className="w-6 h-6"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
        </svg>
      ),
    },
    {
      title: "Vastu Integrated",
      text: "Harmonious spaces designed with traditional Vastu Shastra principles",
      icon: (
        <svg
          className="w-6 h-6"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 2v20M2 12h20M4.93 4.93l14.14 14.14M19.07 4.93L4.93 19.07" />
        </svg>
      ),
    },
    {
      title: "Green Building",
      text: "Eco-conscious materials and sustainable construction techniques",
      icon: (
        <svg
          className="w-6 h-6"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <path d="M17 8C8 10 5.9 16.17 3.82 21.34l1.89.66L7 18.5c1.5 0 3.5-.5 5-2 1.5 1.5 3.5 2 5 2l1.29 3.5 1.89-.66C18.1 16.17 16 10 17 8z" />
          <path d="M12 2a10 10 0 0110 10c0 5.52-4.48 10-10 10" />
        </svg>
      ),
    },
    {
      title: "Craftsmanship",
      text: "Meticulous attention to detail in every corner of your home",
      icon: (
        <svg
          className="w-6 h-6"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" />
        </svg>
      ),
    },
  ];

  return (
    <section
      id="about"
      className="py-20 md:py-28 px-8 md:px-16 bg-nestlent-off-white"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        {/* Images */}
        <Reveal className="relative h-[400px] md:h-[560px]">
          <img
            className="absolute top-0 left-0 w-3/4 h-[82%] object-cover rounded-sm shadow-[0_20px_60px_rgba(0,0,0,0.15)]"
            src="/WhatsApp_Image_2026-03-23_at_10_11_46_AM.jpeg"
            alt="Nestlent project"
          />
          <img
            className="absolute right-0 bottom-0 w-[55%] h-[55%] object-cover rounded-sm shadow-[0_20px_60px_rgba(0,0,0,0.12)] border-4 border-white hidden md:block"
            src="/WhatsApp_Image_2026-03-23_at_10_11_51_AM.jpeg"
            alt="Nestlent interior"
          />
          <div className="absolute left-[60%] top-[38%] -translate-y-1/2 bg-nestlent-green text-white p-4 rounded-sm text-center shadow-[0_10px_40px_rgba(26,107,74,0.4)] z-[2]">
            <div className="font-serif text-[2rem] font-light leading-none">
              8+
            </div>
            <div className="text-[0.6rem] tracking-[0.15em] uppercase opacity-80">
              Years of
              <br />
              Excellence
            </div>
          </div>
        </Reveal>

        {/* Text */}
        <div>
          <Reveal>
            <div className="text-[0.68rem] font-normal tracking-[0.35em] uppercase text-nestlent-green mb-3">
              About Nestlent
            </div>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="font-serif text-[clamp(2.2rem,4vw,3.4rem)] font-light leading-[1.12] text-nestlent-charcoal mb-6">
              Where{" "}
              <em className="font-serif italic text-nestlent-green">Vision</em>
              <br />
              Meets Craft
            </h2>
          </Reveal>
          <Reveal delay={200}>
            <div className="w-12 h-px bg-nestlent-green mb-7" />
          </Reveal>

          {/* Vision Statement */}
          <Reveal delay={200}>
            <div className="bg-nestlent-green-pale border-l-2 border-nestlent-green p-5 rounded-sm mb-6">
              <div className="text-[1.5rem] font-bold tracking-[0.2em] uppercase text-nestlent-green mb-2">
                {" "}
                Our Vision
              </div>
              <p className="text-[0.95rem] font-light leading-[1.8] text-nestlent-charcoal italic">
                Make your dream a reality with our unparalleled expertise,
                commitment to quality, and dedicated team. We deliver
                outstanding craftsmanship and exceptional service, ensuring
                exemplary homes for our clients. Together, let's create
                harmonious spaces through our Vastu-integrated green building
                techniques.
              </p>
            </div>
          </Reveal>

          <Reveal delay={280}>
            <p className="text-[0.98rem] font-light leading-[1.85] text-nestlent-grey mb-5">
              Nestlent Builders and Developers is a premier architecture and
              construction firm rooted in Kerala's rich architectural heritage.
              We blend the timeless beauty of traditional Kerala design with the
              clean lines of contemporary aesthetics.
            </p>
          </Reveal>
          <Reveal delay={350}>
            <p className="text-[0.98rem] font-light leading-[1.85] text-nestlent-grey mb-8">
              Our team of dedicated architects and designers approaches every
              project as a unique story — listening deeply to your aspirations,
              understanding your land, and crafting a home that truly belongs.
            </p>
          </Reveal>
          <Reveal delay={400}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {values.map((v) => (
                <div
                  key={v.title}
                  className="p-5 border border-nestlent-grey-light rounded-sm transition-all duration-300 hover:border-nestlent-green hover:bg-nestlent-green-pale group"
                >
                  <div className="text-nestlent-green mb-3 transition-colors duration-300 group-hover:text-nestlent-green-light">
                    {v.icon}
                  </div>
                  <div className="text-[0.85rem] font-medium text-nestlent-charcoal mb-1">
                    {v.title}
                  </div>
                  <div className="text-[0.78rem] text-nestlent-grey leading-[1.6]">
                    {v.text}
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
